// See https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
// See https://stackoverflow.com/a/48161723/1747491
export default async function sha256(message) {
    // crypto.subtle is only available in secure contexts (HTTPS or localhost).
    // In local dev with .quantic.test hostnames over HTTP, it's undefined.
    if (!crypto?.subtle && window.preloadedConfig?.rails_env === 'development') return undefined;

    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}
